import {
  C_CARD_CLASSNAME,
  C_VIDEO_CARD_INLINE_CLASSNAME,
  C_VIDEO_CARD_INLINE_SLIM_CLASSNAME,
} from '../../components/4-organisms/playlist-carousel-inline/costants';

import widget from './widget';

// This is the configuration for the PlaylistCarouselInline widget
// the width should be with margin/padding calculated aswell

export default {
  ...widget,
  cardsToSlide: 1,
  cardTag: 'a',
  cardWidth: {
    [C_CARD_CLASSNAME]: {
      mobile: 168,
      desktop: 335,
    },
    [C_VIDEO_CARD_INLINE_CLASSNAME]: {
      mobile: 298,
      desktop: 298,
    },
    [C_VIDEO_CARD_INLINE_SLIM_CLASSNAME]: {
      mobile: 320,
      desktop: 302,
    },
  },
};
